'use es6';

import { getSurveyQuestions, createGetSurveyQuestions } from '../api/SurveyMonkeyApi';
import * as CacheKeys from '../constants/CacheKeys';
import createSimpleCachedReferenceResolver from '../lib/createSimpleCachedReferenceResolver';
export const createSurveyMonkeyQuestionReferenceResolver = options => createSimpleCachedReferenceResolver(Object.assign({
  cacheKey: CacheKeys.SURVEY_QUESTIONS,
  createFetchData: createGetSurveyQuestions,
  fetchData: getSurveyQuestions
}, options));
export default createSurveyMonkeyQuestionReferenceResolver();